export const initialState = {
    prequal__header: 'What Sonic service is available to me?',

    street__label: 'Street Address',
    street__placeholder: 'Street Address',

    zip__label: 'Zip Code',
    zip__placeholder: 'Zip Code',

    secondary__label: 'Apt or Suite #',
    secondary__placeholder: 'Apt or Suite #',

    service_types__label: 'I need service for a:',

    service_type_residential__label: 'Home',
    
    service_type_business__label: 'Business',
    service_type_business__title: 'Recommended for 6 or more work stations',

    prequalsubmit__button: 'Check Availability',

    secondary_modal__header: 'According to our records, this address has an apartment or suite number',
    secondary_modal__description: 'If you have an apartment or suite number, please enter it below before continuing',
    secondarysubmit__button: 'Continue',

    secondary2__label: 'Apt or Suite # (If you have one)',
    secondary2__placeholder: 'Apt or Suite #',
    is_secondary_modal_visible: false,

    street_required: 'Street Address is required',
    zip_required: 'Zip Code is required',

    address_not_recognized: "We're sorry, we don't recognize that address. Please ensure that it is correct and click 'Check Availability'",
    address_verification_error: "We encountered an error validating your address. Please ensure that it is correct and click 'Check Availability' to continue."
};

export default function layout (state, action) {
    if(typeof state === 'undefined') {
        state = { ...initialState, hydrated: true }
    }
    else if (!state.hydrated) {
        state = { ...initialState, ...state, hydrated: true }
    }

    switch(action.type) {
        case 'SUGGEST_SECONDARY':
            return {
                ...state,
                is_secondary_modal_visible: true
            };
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/layout.js